// First: an invite link's token (/invite#<token>) leaves the address bar before Sentry, analytics or the router read it.
import './inviteArrival'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import './sentry'
import { reloadOnStaleChunks } from '@/lib/staleChunks'
import App from './App'
import { CloudflareAnalytics } from '@/components/CloudflareAnalytics'
import { FramedNotice } from '@/components/framed/FramedNotice'
import { ProductAnalyticsIdentity, ProductAnalyticsProvider } from '@/components/ProductAnalytics'
import './index.css'
import { AuthProvider } from './state/AuthContext'

reloadOnStaleChunks()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ProductAnalyticsProvider>
      <CloudflareAnalytics />
      <BrowserRouter>
        <FramedNotice />
        <AuthProvider>
          <ProductAnalyticsIdentity />
          <App />
        </AuthProvider>
      </BrowserRouter>
    </ProductAnalyticsProvider>
  </React.StrictMode>
)
